import { MCCSummaryItem } from '@types';

export const hasOutcomeOnMCC = (mccSummaryData?: MCCSummaryItem) => {
	return mccSummaryData?.meterCaseOutcome != null;
};
